import { FC, useState } from 'react';
import { MdPhoneCallback } from 'react-icons/md';
import { ClientCommentIcon } from '../../../../../assets/svg/client-comment';
import { FeedbackIcon } from '../../../../../assets/svg/feedback';
import { OrderCommentIcon } from '../../../../../assets/svg/order-comment';
import { Button } from '../../../../../components/button/button';
import { IconButton } from '../../../../../components/icon-button/icon-button';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { Tooltip } from '../../../../../features/tooltip/tooltip';
import { useLang } from '../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../hooks/use-modal-params';
import { TaskType } from '../../../../../store/api/tasks-api';
import { useReviewsStore } from '../../../../../store/use-reviews-store';
import { FormsIcon } from '../../../navigation/icons/forms';
import s from './tasks-info.module.css';

interface Props {
  task: TaskType;
}

export const TasksInfo: FC<Props> = ({ task }) => {
  const { t } = useLang();
  const { createReview, isLoadingFetch } = useReviewsStore();
  const [isOpen, setIsOpen] = useState(false);

  const isExistExtraInfo =
    !!task.additional_info.dishes?.length ||
    task.payment_method ||
    task.photo ||
    !!task.status_history.length;

  const taskInfoModal = useModalParams('taskInfo');
  const taskFormModal = useModalParams('taskForm');
  const taskCallbackModal = useModalParams('taskCallback');

  return (
    <div className={s.feature}>
      <IconButton
        onClick={() => taskInfoModal.handleOpenModal({ taskId: task.id })}
        disabled={!isExistExtraInfo}
        tooltip={t('Дополнительная информация')}
      >
        <FeedbackIcon />
      </IconButton>
      <IconButton
        disabled={!task.comment}
        tooltip={`${t('Комментарий сотрудника')}: ${task.comment}`}
      >
        <OrderCommentIcon />
      </IconButton>
      <Tooltip
        offset={12}
        open={isOpen}
        onOpen={setIsOpen}
        disabled={!task.client_comment}
        trigger={
          <IconButton
            disabled={!task.client_comment}
            tooltip={`${t('Комментарий клиента')}: ${task.client_comment}`}
            onClick={() => setIsOpen(true)}
          >
            <ClientCommentIcon />
          </IconButton>
        }
      >
        <HasAccess service="task" permissions={['write']}>
          <div className={s.assign}>
            <Button
              disabled={isLoadingFetch}
              onClick={async () => {
                if (!task.qr) return;

                await createReview({
                  content: task.client_comment,
                  qr_id: task.qr?.id,
                  place_id: task.place_id,
                  task_id: task.id,
                });
                setIsOpen(false);
              }}
            >
              {t('Присвоить к отзывам')}
            </Button>
          </div>
        </HasAccess>
      </Tooltip>
      <IconButton
        disabled={!task.callback}
        tooltip={t('Обратная связь')}
        onClick={() =>
          taskCallbackModal.handleOpenModal({ callback: JSON.stringify(task.callback) })
        }
      >
        <MdPhoneCallback />
      </IconButton>
      <IconButton
        onClick={() => taskFormModal.handleOpenModal({ form: task.form_data! })}
        disabled={!task.form_data}
        tooltip={t('Форма')}
      >
        <FormsIcon />
      </IconButton>
    </div>
  );
};
